import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {SaleInvoiceConfigurationModel} from '../../../api/entity/saleInvoiceConfiguration.model';



@Injectable({providedIn: 'root'})
export class SaleInvoiceConfigurationRepository extends AbstractRepositoryV2<SaleInvoiceConfigurationModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('SaleInvoiceConfiguration', serviceElementsFactory, injector);
    }
}
